var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-end"},[_c('div',{staticClass:"status-container",class:`status-${_vm.status} status-${_vm.target}`},[_vm._v(_vm._s(_vm.$t('status.'+_vm.status)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }